// skipcq: JS-W1028
import { useContext, useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';

import { UserContext } from '../context/UserContext';
import { resolveUserWelcomeName } from '../utils/user/resolveUserWelcomeName';
import { db } from '../utils/firebase';

function useUserWelcomeName() {
  const { uid, userEmail, isLoggedIn } = useContext(UserContext);
  const activeUid = isLoggedIn && typeof uid === 'string' ? uid : null;
  const [welcomeNameState, setWelcomeNameState] = useState({
    uid: null,
    value: '',
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (activeUid === null) {
      setWelcomeNameState({ uid: null, value: '' });
      setIsLoading(false);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      setIsLoading(true);
      try {
        const userSnap = await getDoc(doc(db, 'users', activeUid));
        if (cancelled) {
          return;
        }
        const userDoc = userSnap.exists() ? userSnap.data() : null;
        setWelcomeNameState({
          uid: activeUid,
          value: resolveUserWelcomeName(userDoc, userEmail),
        });
      } catch {
        if (!cancelled) {
          setWelcomeNameState({
            uid: activeUid,
            value: resolveUserWelcomeName(null, userEmail),
          });
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [activeUid, userEmail]);

  return {
    welcomeName:
      welcomeNameState.uid === activeUid ? welcomeNameState.value : '',
    isLoading,
  };
}

export default useUserWelcomeName;
